import { createElement, Fragment, useEffect, useState } from 'react';
import rehypeParse from 'rehype-parse';
import rehypeReact from 'rehype-react';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import { unified } from 'unified';
const DefaultAllowedTags = [];
export const HtmlStringToReact = (props) => {
    const { allowedTags = DefaultAllowedTags, text } = props;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    const [content, setContent] = useState(<Fragment />);
    useEffect(() => {
        var _a;
        let shouldSetState = true;
        const components = (_a = defaultSchema.tagNames) === null || _a === void 0 ? void 0 : _a.reduce((acc, value) => {
            if (allowedTags.includes(value)) {
                return acc;
            }
            return Object.assign(Object.assign({}, acc), { [value]: Fragment });
        }, {});
        unified()
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .use(rehypeParse, { fragment: true })
            .use(rehypeSanitize)
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .use(rehypeReact, {
            createElement,
            Fragment,
            components,
        })
            .process(text)
            .then(file => {
            if (shouldSetState) {
                setContent(file.result);
            }
        });
        return () => {
            shouldSetState = false;
        };
    }, [allowedTags, text]);
    return content;
};
